import sha256 from "crypto-js/sha256";
import { v4 } from "uuid";

import { Photo, UnUploadedImage } from "components/PhotoUpload/types";

import { formatImage } from "./formatImage";

type Option = {
  file: File;
  type: Photo;
  alt: string;
};
export const processImageForUpload = async ({ file, type, alt }: Option): Promise<UnUploadedImage> => {
  const id = v4();
  const names = file.name.split(".");
  const ext = names[names.length - 1];
  const clientImageId = `${type}-${id}.${ext}`;

  try {
    let formattedBase64Image = (await formatImage(file)) as string;
    // Avoid returning always base64string when using File()
    formattedBase64Image = formattedBase64Image === 'base64string' ? file.name : formattedBase64Image
    const imageHash = sha256(formattedBase64Image).toString();

    return {
      id,
      type,
      base64: formattedBase64Image,
      src: formattedBase64Image,
      alt,
      clientImageId,
      hash: imageHash,
    };
  } catch (e) {
    throw new Error("Could not process image");
  }
};
